import { IHomework } from "../model";
import moment from "moment";

export const homeworkInitial: IHomework = {
  classroomId:0,
  schoolId:0,
  organizationId:0,
  storyId:0,
  startDate:moment().utc().toDate(),
  endDate:moment().utc().add(1,"day").toDate(),
  isReadAloud: false,
  requestVoiceRecording: false,
  languageCode: 'tr-TR',
}
